/*
 * GUIDs for addins
 */

export const shareToTeamsGUIDs: string[] = ["545d8236-721a-468f-85d8-254eca7cb0da"];
